/** @jsx jsx */
import { jsx } from '@emotion/react';
import { editIconStyles } from '@atlaskit/editor-common/styles';
import EditIcon from '@atlaskit/icon/glyph/edit';

/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */
export var SmallerEditIcon = function SmallerEditIcon() {
  return jsx("div", {
    css: editIconStyles
  }, jsx(EditIcon, {
    label: "edit"
  }));
};
/* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */